import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useIntercom } from "react-use-intercom";
import { ReactComponent as ArrowSVG } from "../../../../../../../images/svg/subscriptions/arrow.svg";
import { ReactComponent as HelpSVG } from "../../../../../../../images/svg/subscriptions/help.svg";

const SubscriptionNeedHelp = () => {
	const { t } = useTranslation();
	const { show } = useIntercom();

	return (
		<div className="subscription-need-help-container">
			<div className="d-flex flex-column align-items-center">
				<HelpSVG className="mb-3" />
				<h5 className="mb-2">{t("modules.subscription.field.need_help.title")}</h5>
				<p className="text-muted mb-2">{t("modules.subscription.field.need_help.description")}</p>
				<Button onClick={show}>
					{t("modules.subscription.action.start_conversation.title")}
					<ArrowSVG className="ms-3" />
				</Button>
			</div>
		</div>
	);
};

export default SubscriptionNeedHelp;
